import './App.scss';
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/unit/Header";
import Footer from "./components/unit/Footer";
import Home from "./pages/Home";
import Service from "./pages/Service";
import Music from "./pages/Music";
import Portfolio from "./pages/Portfolio";
import Recruit from "./pages/Recruit";

function App() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);  
  return (
    <>
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/music" element={<Music />} />
      <Route path="/service" element={<Service />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/recruit" element={<Recruit />} />
    </Routes>    
    <Footer />
    </>
  );
}

export default App;
